import "../Styles/Business_set.css";
import { useNavigate, useLocation } from "react-router-dom";
import { getData, saveData } from "../utils/store-data";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  PHNO,
  PROFILE_LOGIN,
  USER_ID,
} from "../utils/store-data-constants";
import {
  get_castes,
  get_communities,
  get_language,
  get_religios,
  update_profile_photo,
  update_agent,
  get_all_countries,
  get_states,
  get_cities,
  get_all_castes,
  check_email,
  check_phone_no,
  update_business_logo,
  update_promotional_images,
  delete_promotional_image,
} from "../api/serverWrapper";
import { useEffect, useState } from "react";
import Agent from "../components/Agent";
import UserInfo from "../components/UserInfo";
import Select, { components } from "react-select";
import { customStyles, customStylesbusiness } from "../utils/commonFunctions";
import { useMasterData } from "../context/MasterDataContext";
import BusinessSetupHeader from "./BusinessSetupHeader";
import BusinessMediaSection from "../components/businessSetup/BusinessMediaSection";
import { IoChevronBackOutline } from "react-icons/io5";

function EditBusiness_set_up({ existingAgent, onClose }) {
  const {
    religionMasterData,
    allCasteMasterData,
    communityMasterData,
    languageMasterData,
    allCountyMasterData,
  } = useMasterData();
  const location = useLocation();
  // const existingAgent = location.state?.existingAgent;
  console.log("existingAgent", existingAgent);
  const navigate = useNavigate();
  let [agentData, setAgentData] = useState(new Agent());
  let [userData, setUserData] = useState(new UserInfo());

  const [businessName, setBusinessName] = useState("");
  const [agentName, setAgentName] = useState("");
  const [experience, setExperience] = useState("");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [originalPhone, setOriginalPhone] = useState("");

  const [religion, setReligion] = useState(religionMasterData || []);
  const [caste, setCaste] = useState(allCasteMasterData || []);
  const [communityList, setCommunity] = useState(communityMasterData || []);
  const [languages, setLanguages] = useState(languageMasterData || []);

  // 👉 store IDs only
  const [selectedReligion, setSelectedReligion] = useState([]);
  const [selectedCaste, setSelectedCaste] = useState([]);
  const [selectedCommunities, setSelectedCommunities] = useState([]);
  const [selectedLanuages, setSelectedLanguages] = useState([]);
  const [EMail, setEMail] = useState("");
  const [originalEmail, setOriginalEmail] = useState("");

  const [agentProfilePreview, setAgentProfilePreview] = useState("");
  const [agentProfileFile, setAgentProfileFile] = useState(null);

  const [businessLogoPreview, setBusinessLogoPreview] = useState("");
  const [businessLogoFile, setBusinessLogoFile] = useState(null);

  const [promoImagePreviews, setPromoImagePreviews] = useState([]);
  const [promoImageFiles, setPromoImageFiles] = useState([]);

  let [UserId, setUserId] = useState(null);

  // Country/State/City
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState(
    existingAgent?.User?.Address?.CountryId || "",
  );
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(
    existingAgent?.User?.Address?.StateId || "",
  );
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(
    existingAgent?.User?.Address?.CityId || "",
  );

  useEffect(() => {
    if (existingAgent) {
      // setAgentData(existingAgent);
      UserId = existingAgent.UserId;
      setUserId(UserId);
      setBusinessName(existingAgent.BusinessName || "");
      setAgentName(existingAgent.User?.FirstName || "");
      setExperience(existingAgent.BusinessExperience || "");
      setAddress(existingAgent.BusinessAddress || "");
      setDescription(existingAgent.BusinessDescription || "");
      const phone = existingAgent.User?.PhoneNumber || "";
      setPhoneNumber(phone);
      setOriginalPhone(phone); // ✅ save original

      const email = existingAgent.User?.EMail || "";
      setEMail(email);
      setOriginalEmail(email); // ✅ store original email

      // ✅ PROFILE IMAGE FIX
      const profileImage = existingAgent.User?.ProfilePhotoUrl;
      if (profileImage) {
        setAgentProfilePreview(profileImage);
      }

      if (existingAgent?.BusinessLogo) {
        setBusinessLogoPreview(existingAgent.BusinessLogo);
      }

      if (existingAgent?.PromotionalImages?.length > 0) {
        setPromoImagePreviews(
          existingAgent.PromotionalImages.map((img) => ({
            preview: img,
            file: null,
          })),
        );
      }

      // IDs only
      setSelectedReligion(existingAgent.ReligionsServe || []);
      setSelectedCaste(existingAgent.CastesServe || []);
      setSelectedCommunities(existingAgent.CommunitesServe || []);
      setSelectedLanguages(existingAgent.LanguagesServe || []);
    }
  }, [existingAgent]);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      let id = await getData(USER_ID);
      setUserId(id);

      await fetchCountries();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCountries = async () => {
    try {
      // const res = await get_all_countries();
      let data = allCountyMasterData;
      if (data) {
        const formatted = data.map((c) => {
          const code = c.phonecode.startsWith("+")
            ? c.phonecode
            : `+${c.phonecode}`;

          return {
            value: c.isoCode,
            label: `${c.name} (${code})`,
            name: c.name,
            phoneCode: c.phonecode,
          };
        });
        setCountries(formatted);
      }
    } catch (err) {
      console.error("Error fetching countries", err);
    }
  };

  useEffect(() => {
    console.log("Selectd countryCode", countryCode);

    if (countryCode) {
      (async () => {
        try {
          console.log("Selectd inside countryCode", countryCode);
          const res = await get_states(countryCode);
          if (res.success) {
            const formattedStates = res.data.map((s) => ({
              value: s.isoCode,
              label: s.name,
              countryCode: s.countryCode,
            }));
            console.log("formattedStates ", formattedStates);

            setStates(formattedStates);
            // setSelectedState(null); // reset state
            // setCities([]); // reset cities
          }
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      })();
    }
  }, [countryCode]);

  // 2️⃣ When state changes, fetch cities
  useEffect(() => {
    if (countryCode && selectedState) {
      (async () => {
        try {
          const res = await get_cities(countryCode, selectedState);
          if (res.success) {
            const formattedCities = res.data.map((c) => ({
              value: c.name,
              label: c.name,
              stateCode: c.stateCode,
              countryCode: c.countryCode,
            }));
            setCities(formattedCities);
            // setSelectedCity(null);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      })();
    }
  }, [selectedState, countryCode]);

  // const casteOptions = [
  //   { value: "all", label: "All Castes" },
  //   ...caste.map((item) => ({
  //     value: item.CasteL2Id,
  //     label: item.CasteName,
  //   })),
  // ];

  const ReligionOptions = [
    { value: "all", label: "All Religions" },
    ...religion.map((item) => ({
      value: item.ReligionId,
      label: item.ReligionName,
    })),
  ];

  // Filter castes based on selected religion
  const filteredCastes =
    selectedReligion.includes("all") || selectedReligion.length === 0
      ? caste
      : caste.filter((c) => selectedReligion.includes(c.ReligionId));

  const casteOptions = [
    { value: "all", label: "All Castes" },
    ...filteredCastes.map((item) => ({
      value: item.CasteL2Id,
      label: item.CasteName,
    })),
  ];

  const communiteOptions = [
    { value: "all", label: "All Communities" },
    ...communityList.map((item) => ({
      value: item.CommunitiesId,
      label: item.CommunitiesName,
    })),
  ];
  const langOptions = [
    { value: "all", label: "All Languages" },
    ...languages.map((item) => ({
      value: item.LangId,
      label: item.LangDesc,
    })),
  ];

  useEffect(() => {
    if (selectedReligion.length === 1 && selectedReligion[0] === "all") {
      setSelectedCaste(["all"]);
    }
  }, [selectedReligion]);

  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            style={{
              width: 16,
              height: 16,
              cursor: "pointer",
            }}
          />

          <span>{props.label}</span>
        </div>
      </components.Option>
    );
  };

  const checkEmailAvailability = async () => {
    if (!EMail) return true;

    try {
      const res = await check_email(EMail);

      if (!res.success) {
        alert(res.message || "Email already exists");
        return false;
      }

      return true;
    } catch (error) {
      console.error(error);
      alert("Error checking email");
      return false;
    }
  };
  const checkPhoneAvailability = async () => {
    if (!PhoneNumber) return true;

    try {
      const res = await check_phone_no(PhoneNumber);

      if (!res.success) {
        alert(res.message || "Phone number already exists");
        return false;
      }

      return true;
    } catch (error) {
      console.error(error);
      alert("Error checking phone number");
      return false;
    }
  };

  const handleBusinessLogoSelection = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setBusinessLogoFile(file);
    setBusinessLogoPreview(URL.createObjectURL(file));
  };

  const handleAgentProfileSelection = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setAgentProfilePreview(URL.createObjectURL(file));
    setAgentProfileFile(file);
  };

  // ----- Save (Update) -----
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    console.log("existingAgent ===", existingAgent);
    if (isSaving) return; // prevent double click

    setIsSaving(true);
    // 🔥 Only check if email was changed
    if (EMail && EMail !== originalEmail) {
      const isEmailValid = await checkEmailAvailability();
      if (!isEmailValid) {
        setIsSaving(false);
        return;
      }
    }

    if (PhoneNumber && PhoneNumber !== originalPhone) {
      const isPhoneValid = await checkPhoneAvailability();
      if (!isPhoneValid) {
        setIsSaving(false);
        return;
      }
    }
    // ✅ Phone validation
    if (PhoneNumber && PhoneNumber.length !== 10) {
      alert("Phone number must be exactly 10 digits");
      setIsSaving(false);
      return;
    }

    let data = {
      PhoneNumber: PhoneNumber,
      FirstName: agentName,
      UserId: UserId,
    };

    const email = EMail?.trim();

    if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      data.EMail = email;
    }

    if (!PhoneNumber) {
      delete data.PhoneNumber;
    }
    if (!EMail) {
      delete data.EMail;
    }

    agentData.BusinessName = businessName;
    agentData.BusinessAddress = address;
    agentData.BusinessDescription = description;
    agentData.BusinessExperience = experience;

    // IDs directly
    agentData.ReligionsServe = selectedReligion;
    agentData.CastesServe = selectedCaste;
    agentData.CommunitesServe = selectedCommunities;
    agentData.LanguagesServe = selectedLanuages;

    if (!countryCode) {
      alert("Select Country");
      setIsSaving(false);
      return;
    }

    if (!selectedState) {
      alert("Select Country");
      setIsSaving(false);
      return;
    }
    if (!selectedCity) {
      alert("Select City");
      setIsSaving(false);
      return;
    }

    agentData.userInfo = data;

    console.log(agentData);

    delete agentData.User;
    delete agentData.AgentId;
    delete agentData.UserId;
    // delete agentData.EMail;

    agentData.address.CountryId = countryCode;
    agentData.address.StateId = selectedState;
    agentData.address.CityId = selectedCity;

    delete agentData.address.AddressDetails;
    delete agentData.address.ResidenceId;
    delete agentData.address.CitizenshipId;
    delete agentData.address.Ethinicity;

    console.log("agentData", agentData);

    try {
      const resp = await update_agent(agentData);
      console.log(resp);
      if (resp.code === 200) {
        // await saveData(USER_ID, resp.data.User.UserId);
        // await saveData(AGENT_LOGIN, true);
        // await saveData(CLIENT_LOGIN, false);
        // await saveData(PROFILE_LOGIN, false);

        if (agentProfileFile) {
          await doUpdateProfileImage(UserId, agentProfileFile);
        }

        if (businessLogoFile) {
          await update_business_logo(UserId, businessLogoFile);
        }

        if (promoImageFiles.length > 0) {
          await update_promotional_images(UserId, promoImageFiles);
        }

        // navigate("/settings");
        if (onClose) {
          onClose();
        }
      } else {
        alert(resp.message);
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong while updating.");
    } finally {
      setIsSaving(false); // ✅ ALWAYS stop spinner
    }
  };

  const doUpdateProfileImage = async (id, selectedFile) => {
    try {
      const response = await update_profile_photo(id, selectedFile);
      console.log(response);

      if (response.status !== 200) {
        alert("Profile photo upload failed.");
      }
    } catch (error) {
      console.error("Image Upload error: ", error);
      alert("Error uploading image.");
    }
  };

  const handleDeletePromoImage = async (imageUrl) => {
    try {
      const actualUrl = imageUrl.split("?")[0];

      console.log(actualUrl);
      
      let data = {
        UserId:UserId,
        ImageUrl:actualUrl,
      }
      const res = await delete_promotional_image(data);

      if (res.code === 200) {
        return true;
      }

      console.log(res);
      

      // alert(res.message);
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return (
    <div>
      {/* <BusinessSetupHeader name={"Edit Business"} /> */}
      <div className="edit-business-header">
        <div
          className="edit-business-back"
          onClick={() => onClose && onClose()}
        >
          <IoChevronBackOutline /> Edit Business details
        </div>

        <div
          className="edit-business-save"
          onClick={!isSaving ? handleSave : undefined}
          style={{
            pointerEvents: isSaving ? "none" : "auto",
            opacity: isSaving ? 0.7 : 1,
            cursor: isSaving ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>{isSaving ? "Saving..." : "Save"}</span>

          {isSaving && <span className="spinner" />}
        </div>
      </div>
      <div>
        <div className="Business-container">
          <h2> Business overview</h2>

          {/* Inputs */}
          <div className="field">
            <label>Business Name</label>
            <input
              type="text"
              placeholder="Enter Business Name"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
          </div>

          <div className="field">
            <label>Enter Agent Name</label>
            <input
              type="text"
              placeholder="Enter Your Name"
              value={agentName}
              onChange={(e) => setAgentName(e.target.value)}
            />
          </div>

          <div className="field">
            <label> Total Business Experience (in years)</label>
            <input
              type="text"
              placeholder="e.g. 5"
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
            />
          </div>

          <div className="field">
            <label>Enter EMail </label>
            <input
              type="text"
              placeholder="Enter EMail"
              value={EMail}
              onChange={(e) => setEMail(e.target.value)}
            />
          </div>

          <div className="field">
            <label>Select Country</label>

            <div className="form-group-new-client">
              <Select
                options={countries}
                placeholder="Select Country"
                value={countries.find((c) => c.value === countryCode) || null}
                onChange={(option) => {
                  setCountryCode(option.value);
                  setSelectedState("");
                  setSelectedCity("");
                }}
                isSearchable
                styles={customStylesbusiness}
              />
            </div>
          </div>

          <div className="field">
            <label>Enter Your PhoneNumber </label>
            <input
              type="text"
              placeholder="Enter Your PhoneNumber"
              maxLength={10}
              value={PhoneNumber}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // remove non-numbers
                setPhoneNumber(value.slice(0, 10)); // limit to 10 digits
              }}
            />
          </div>

          <div className="field">
            <label>Select State</label>

            <Select
              options={states}
              placeholder="Select State"
              value={states.find((s) => s.value === selectedState) || null}
              onChange={(option) => {
                setSelectedState(option ? option.value : "");
                setSelectedCity("");
              }}
              isDisabled={!countryCode}
              isSearchable
              styles={customStylesbusiness}
            />
          </div>
          <div className="field">
            <label>Select City</label>

            <Select
              options={cities}
              placeholder="Select City"
              value={cities.find((c) => c.value === selectedCity) || null}
              onChange={(option) => setSelectedCity(option ? option.value : "")}
              isDisabled={!selectedState}
              isSearchable
              styles={customStylesbusiness}
            />
          </div>

          <div className="field">
            <label>Business Address</label>

            <textarea
              placeholder=" Example -Shop No 4, Panchayat Bhawan, Alwar Road, Gurgaon, Gurgaon"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              rows={4} // you can adjust the number of rows as needed
            />
          </div>

          <div className="field">
            <label>Business description</label>
            <textarea
              type="text"
              placeholder="Business description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>

        {/* Dropdowns + tags */}
        <div className="Business-container mt-4">
          <h2> Business Details</h2>

          {/* Religion */}

          <div className="field">
            <label>Religions you serve</label>
            <Select
              options={ReligionOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              styles={{
                ...customStylesbusiness,
                option: (provided) => ({
                  ...provided,
                  backgroundColor: "white",
                  color: "#333",
                  cursor: "pointer",
                  ":hover": {
                    backgroundColor: "#f3f4f6",
                  },
                }),
                multiValue: (provided) => ({
                  ...provided,
                  backgroundColor: "#f1f5f9",
                }),
              }}
              placeholder="Select Religions"
              value={
                selectedReligion.includes("all")
                  ? [{ value: "all", label: "All Religions" }]
                  : ReligionOptions.filter((opt) =>
                      selectedReligion.includes(opt.value),
                    )
              }
              onChange={(opts) => {
                if (!opts || opts.length === 0) {
                  setSelectedReligion([]);
                  return;
                }

                const values = opts.map((o) => o.value);

                // 👉 Clicking ALL
                if (
                  values.includes("all") &&
                  !selectedReligion.includes("all")
                ) {
                  setSelectedReligion(["all"]);
                  return;
                }

                // 👉 ALL already selected + user clicks individual
                if (selectedReligion.includes("all")) {
                  setSelectedReligion(values.filter((v) => v !== "all"));
                  return;
                }

                // 👉 Normal multi select
                setSelectedReligion(values);
              }}
            />
          </div>

          <div className="field">
            <label>Castes you serve</label>
            <Select
              options={casteOptions}
              isMulti
              isSearchable
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              styles={customStylesbusiness}
              placeholder="Search castes..."
              value={
                selectedCaste.includes("all")
                  ? [{ value: "all", label: "All Castes" }]
                  : casteOptions.filter((opt) =>
                      selectedCaste.includes(opt.value),
                    )
              }
              onChange={(opts) => {
                if (!opts || opts.length === 0) {
                  setSelectedCaste([]);
                  return;
                }

                const values = opts.map((o) => o.value);

                if (values.includes("all") && !selectedCaste.includes("all")) {
                  setSelectedCaste(["all"]);
                  return;
                }

                if (selectedCaste.includes("all")) {
                  setSelectedCaste(values.filter((v) => v !== "all"));
                  return;
                }

                setSelectedCaste(values);
              }}
            />
          </div>

          {/* Communities */}

          <div className="field">
            <label>Communities you serve</label>
            <Select
              options={communiteOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              styles={customStylesbusiness}
              placeholder="Select Communities"
              value={
                selectedCommunities.includes("all")
                  ? [{ value: "all", label: "All Communities" }]
                  : communiteOptions.filter((opt) =>
                      selectedCommunities.includes(opt.value),
                    )
              }
              onChange={(opts) => {
                if (!opts || opts.length === 0) {
                  setSelectedCommunities([]);
                  return;
                }

                const values = opts.map((o) => o.value);

                if (
                  values.includes("all") &&
                  !selectedCommunities.includes("all")
                ) {
                  setSelectedCommunities(["all"]);
                  return;
                }

                if (selectedCommunities.includes("all")) {
                  setSelectedCommunities(values.filter((v) => v !== "all"));
                  return;
                }

                setSelectedCommunities(values);
              }}
            />
          </div>

          {/* Languages */}

          <div className="field">
            <label>Languages you serve</label>
            <Select
              options={langOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              styles={customStylesbusiness}
              placeholder="Select Languages"
              value={
                selectedLanuages.includes("all")
                  ? [{ value: "all", label: "All Languages" }]
                  : langOptions.filter((opt) =>
                      selectedLanuages.includes(opt.value),
                    )
              }
              onChange={(opts) => {
                if (!opts || opts.length === 0) {
                  setSelectedLanguages([]);
                  return;
                }

                const values = opts.map((o) => o.value);

                if (
                  values.includes("all") &&
                  !selectedLanuages.includes("all")
                ) {
                  setSelectedLanguages(["all"]);
                  return;
                }

                if (selectedLanuages.includes("all")) {
                  setSelectedLanguages(values.filter((v) => v !== "all"));
                  return;
                }

                setSelectedLanguages(values);
              }}
            />
          </div>
        </div>

        {/* Profile Image */}
        {/* <div className="profile-image">
          <h2>Profile photo</h2>
          <p>optional</p>
          <div className="Business_symbol">
            <label htmlFor="imageUpload" className="upload-label">
              <img
                src={imageSource}
                alt="Profile Preview"
                className="preview-image"
              />
              <div className="plus-icon-for-agent">
                <span style={{ color: "#B35381", fontSize: 30 }}> +</span>
              </div>
            </label>
            <input
              id="imageUpload"
              type="file"
              accept="image/*"
              onChange={handleImageSelection}
              className="hidden-input"
            />
          </div>
        </div> */}

        <BusinessMediaSection
          businessLogoPreview={businessLogoPreview}
          handleBusinessLogoSelection={handleBusinessLogoSelection}
          setBusinessLogoPreview={setBusinessLogoPreview}
          agentProfilePreview={agentProfilePreview}
          handleAgentProfileSelection={handleAgentProfileSelection}
          setAgentProfilePreview={setAgentProfilePreview}
          promoImagePreviews={promoImagePreviews}
          setPromoImagePreviews={setPromoImagePreviews}
          setPromoImageFiles={setPromoImageFiles}
          onDeletePromoImage={handleDeletePromoImage}
        />

        <div className="footer-reg">
          <div
            onClick={!isSaving ? handleSave : undefined}
            style={{
              pointerEvents: isSaving ? "none" : "auto",
              opacity: isSaving ? 0.6 : 1,
              cursor: isSaving ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <h3 style={{ margin: 0 }}>
              {isSaving ? "Updating" : "Update Business ›"}
            </h3>

            {isSaving && <span className="spinner" />}
          </div>
        </div>

        <div className="business_footer_line"></div>
      </div>
    </div>
  );
}

export default EditBusiness_set_up;
